import { Grid, Typography, SxProps, Theme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Canvas3D } from "../components/Canvas3D";
import ReinovaButton from "../components/ReinovaButton";
import PageContent from "../components/PageContent";
import { useIsMobile } from "../hooks";
import VirtualTourButton from "../components/VirtualTourButton";


const HomepageStyle: Record<string, SxProps<Theme>> = {
    button: {
        background: (theme: Theme) => `linear-gradient(90deg, ${theme.palette.primary.main}, rgb(250, 224, 66))`,
    }
}

const Homepage = () => {
    let navigate = useNavigate();
    const { isMobile } = useIsMobile();

    return (
        <>
        <Typography variant="h6">Your One-Stop Partner for Electrification</Typography>
        <PageContent>
            <Grid container sx={{ gap: isMobile ? 4 : 0 }}>
                <Grid item md={5} sm={12} xs={12}>
                    <Canvas3D height={isMobile ? "80vw" : "32vw"} width="100%" model="testing.gltf" texture="baked2.webp" isMobile={isMobile}/>
                    <ReinovaButton
                        onClick={() => navigate("/testing")}
                        color="testing.main"
                        background="testing.dark"
                        height={!isMobile ? "80px" : undefined}
                        width={!isMobile ? "220px" : undefined}
                    >
                        TESTING, INSPECTION & CERTIFICATION
                    </ReinovaButton>
                </Grid>
                <Grid container md={2} justifyContent={"center"} alignItems={"flex-end"}>
                    <VirtualTourButton/>
                </Grid>
                <Grid item md={5} sm={12} xs={12}>
                    <Canvas3D height={isMobile ? "80vw" : "32vw"} width="100%" model="technology.gltf" texture="baked.png" isMobile={isMobile}/>
                    <ReinovaButton
                        onClick={() => navigate("/software")}
                        color="software.main"
                        background="software.dark"
                        height={!isMobile ? "80px" : undefined}
                        width={!isMobile ? "220px" : undefined}
                    >
                        CONNECTIVE ENGINEERING
                    </ReinovaButton>
                </Grid>
            </Grid>
        </PageContent>
        </>
    );
};

export default Homepage;
